import { render } from "./App.vue?vue&type=template&id=13a36210"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/css/base.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=13a36210&lang=css"

import exportComponent from "F:\\git\\myProject\\wbgltd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__